import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ExcalidrawApp from "../App";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import Login from "./pages/Login";

const WHITEBOARD_ROUTE = "/whiteboard";

function RootRedirect() {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return null;
  }

  return (
    <Navigate
      to={isAuthenticated ? WHITEBOARD_ROUTE : "/login"}
      replace
    />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />

          <Route
            path={WHITEBOARD_ROUTE}
            element={
              <ProtectedRoute>
                <ExcalidrawApp />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
